<template>
  <div class="pdf-viewer">
    <!-- Для Telegram Mini App показываем кнопки вместо iframe -->
    <div v-if="isTelegramWebApp" class="pdf-telegram-view">
      <div class="pdf-placeholder">
        <div class="pdf-icon">📄</div>
        <div class="pdf-title">PDF документ</div>
        <div class="pdf-description">
          Для просмотра PDF файла в Telegram Mini App используйте кнопки ниже
        </div>
        <div class="pdf-actions">
          <a-button 
            type="primary" 
            size="large"
            @click="openInNewTab"
            style="margin-right: 12px;"
          >
            Открыть в браузере
          </a-button>
          <a-button 
            type="default" 
            size="large"
            @click="downloadFile"
          >
            Скачать
          </a-button>
        </div>
      </div>
    </div>
    
    <!-- Для обычного браузера показываем iframe -->
    <div v-else class="pdf-browser-view">
      <iframe
        :src="pdfUrl"
        class="pdf-iframe"
        title="PDF документ"
      ></iframe>
      <div class="pdf-actions">
        <a-button type="primary" @click="downloadFile">
          Скачать PDF
        </a-button>
      </div>
    </div>
  </div>
</template>

<script>
import { computed } from 'vue';

export default {
  name: 'PdfViewer',
  props: {
    pdfUrl: {
      type: String,
      required: true
    },
    filename: {
      type: String,
      default: 'document.pdf'
    }
  },
  setup(props) {
    // Проверяем, запущено ли приложение в Telegram Mini App
    const isTelegramWebApp = computed(() => {
      return window.Telegram && window.Telegram.WebApp;
    });

    // Открытие PDF в новой вкладке
    const openInNewTab = () => {
      window.open(props.pdfUrl, '_blank');
    };

    // Скачивание PDF файла
    const downloadFile = () => {
      const link = document.createElement('a');
      link.href = props.pdfUrl;
      link.download = props.filename;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    };

    return {
      isTelegramWebApp,
      openInNewTab,
      downloadFile
    };
  }
};
</script>

<style scoped>
.pdf-viewer {
  width: 100%;
  height: 100%;
}

.pdf-telegram-view {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 400px;
}

.pdf-placeholder {
  text-align: center;
  padding: 40px 20px;
  background: #f5f5f5;
  border-radius: 8px;
  max-width: 400px;
  width: 100%;
}

.pdf-icon {
  font-size: 48px;
  color: #1890ff;
  margin-bottom: 16px;
}

.pdf-title {
  font-size: 18px;
  font-weight: 500;
  color: #333;
  margin-bottom: 8px;
}

.pdf-description {
  font-size: 14px;
  color: #666;
  margin-bottom: 24px;
  line-height: 1.5;
}

.pdf-actions {
  display: flex;
  justify-content: center;
  gap: 12px;
  flex-wrap: wrap;
}

.pdf-browser-view {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.pdf-iframe {
  width: 100%;
  height: 500px;
  border: none;
  border-radius: 4px;
  margin-bottom: 16px;
}

@media (max-width: 768px) {
  .pdf-actions {
    flex-direction: column;
    align-items: center;
  }
  
  .pdf-actions .ant-btn {
    width: 100%;
    max-width: 200px;
  }
}
</style> 